const DateFormat = {
  DATE_AND_TIME: 'DD/MM/YYYY HH:mm',
}

export { DateFormat }
